<!-- CountDown.vue -->
<script lang="ts" setup>
    import { TimeLeft, timeLeft, timeLeftString } from '../lib/TimeUtils';
    import IntervalUpdate from './IntervalUpdate.vue';

    const props = withDefaults(defineProps<{
        expires?: number|Date,  // Date when we'll expire
        interval?: number       // Refresh interval in milliseconds
        }>(), {
            interval: 500
        });

    const emits = defineEmits<{
        (e: "expired"): void
    }>();

    function getTimeLeft(): TimeLeft|undefined
    {
        const timeLeftVal = timeLeft(props.expires);
        if (timeLeftVal)
        {
            if ((timeLeftVal.hours ?? 0)<= 0 && (timeLeftVal.minutes ?? 0) <= 0 && (timeLeftVal.seconds ?? 0) <= 0)
                emits("expired");
        }

        return timeLeftVal;
    }

</script>

<template>
    <IntervalUpdate>
        <slot name="format" :remaining="getTimeLeft()">
            {{timeLeftString(getTimeLeft())}}
        </slot>
    </IntervalUpdate>

</template>